"use client";

import type { CSSProperties } from "react";

export interface LastUsedLoginChipProps {
  label?: string;
  className?: string;
  style?: CSSProperties;
}

export function LastUsedLoginChip({
  label = "Last used",
  className,
  style,
}: LastUsedLoginChipProps) {
  return (
    <span
      aria-label={label}
      className={className}
      style={{
        alignItems: "center",
        backgroundColor: "#14532D",
        borderRadius: 999,
        color: "#F0FDF4",
        display: "inline-flex",
        fontSize: 11,
        fontWeight: 700,
        justifyContent: "center",
        lineHeight: "14px",
        minHeight: 22,
        padding: "4px 10px",
        whiteSpace: "nowrap",
        ...style,
      }}
    >
      {label}
    </span>
  );
}

export default LastUsedLoginChip;

